/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import StatusTracking from '../../../common/StatusTracking';
import configEnv from '../../../config';

class DesktopOrderTrackingPlants extends React.Component {
    openTrakingWindow = (trackingUrl) => {
        if (typeof window !== 'undefined') window.open(trackingUrl);
    };

    render() {
        const {
            // eslint-disable-next-line object-curly-newline
            data: { status, trackingNumber, carrier, isPassport },
        } = this.props;

        // I -> In transit
        // D/U -> Delivered
        // C -> Cancelled
        // W and all other status -> Order Received

        let trackingUrl;
        const statusBar = isPassport ? 'D' : status;

        if (['FEDEX', 'UPS', 'USPS'].includes(carrier)) {
            trackingUrl = `${configEnv[`${carrier}_ORDERTRACKING_URL`]}${trackingNumber}`;
        } else if (trackingNumber) {
            let company = /^1Z/.test(trackingNumber) ? 'UPS' : 'FEDEX';
            company = /^92/.test(trackingNumber) ? 'USPS' : company;

            trackingUrl = `${configEnv[`${company}_ORDERTRACKING_URL`]}${trackingNumber}`;
        }

        const orderStatus = ['W', 'I', 'CONFIRMED', 'IN TRANSIT', 'DELIVERED'];

        return (
            <>
                <Grid item md={3} lg={3} className="sm-hide">
                    <StatusTracking status={statusBar} brand="pla" />
                </Grid>
                <Grid item xs={6} sm={6} md={2} lg={2}>
                    {orderStatus.indexOf(statusBar) > -1 ? (
                        <>
                            <Grid xs={12} sm={12} className="sm-screen sm-mt-3">Tracking Number:</Grid>
                            <div>
                                {trackingNumber ? (
                                    <span>
                                        {trackingUrl ? (
                                            <a
                                                className="link"
                                                onClick={() => this.openTrakingWindow(trackingUrl)}
                                            >
                                                {trackingNumber}
                                            </a>
                                        ) : (
                                            { trackingNumber }
                                        )}
                                    </span>
                                ) : (
                                    <span>Available on day of shipment</span>
                                )}
                            </div>
                        </>
                    ) : (
                        ''
                    )}
                </Grid>
                <Grid item xs={12} sm={12} className="sm-screen sm-mt-3">
                    <Grid xs={12} sm={12} className="sm-screen">Order Status:</Grid>
                    <StatusTracking status={statusBar} brand="pla" />
                </Grid>
            </>
        );
    }
}

DesktopOrderTrackingPlants.propTypes = {
    data: PropTypes.object.isRequired,
};

export default DesktopOrderTrackingPlants;
